module.exports = __webpack_public_path__ + "img/pdf.085ebc9d.svg";